import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private platformId = inject(PLATFORM_ID);

  trackPageView(path: string) {
    if (!isPlatformBrowser(this.platformId)) return;
    const win = window as any;
    if (win && typeof win.gtag === 'function') {
      win.gtag('event', 'page_view', { page_path: path, page_title: path });
    }
  }
}
